

















































import Vue from "vue";
import ComponetLoader from './components/ComponentLoader.vue';
import { Component,Watch,Prop } from "vue-property-decorator";
import { AppConstants as _app } from "@/shared/app.constants";
@Component({
     components: {
       ComponetLoader
    }
})
export default class CommunicationsGridComponent extends Vue {
  @Prop() context;
  @Prop() items;
  @Prop() id;
  disabled=false;
  showEdit=false
  data : any={};
  close()
  {
    this.disabled=true
    this.showEdit=true
  }
  edit()
  {
    this.showEdit=false;
    this.disabled=false
  }
  save()
  {
    if(this.data['Initiative'])
    {
    delete this.data['Initiative']
    }
    if(this.context=="create")
    {
     if ((this.$refs.commiunicationReportForm as Vue & { validate: () => boolean }).validate())
     {
    this.$emit("save",this.data)
     }
    }
    if(this.context=="update")
    {
      if ((this.$refs.commiunicationReportForm as Vue & { validate: () => boolean }).validate())
     {
      this.$emit("update",this.data)
     }
    }
  }
  back()
  {
    this.$emit("close",{})
  }
  change(e)
  {
    if(e.type=="Initiative")
    {
      this.$services.commiunicationReport.GetInitiative(e.value).then(resp=>{
        if(resp.Result=="OK"){
          this.items.find((x) => x.text == "Call").items = resp.Record ;
        }
      })
    }
    if(e.type=="Template")
    {
       this.$services.commiunicationReport.GetSteps(e.value).then(resp=>{
        if(resp.Result=="OK"){
          this.items.find((x) => x.text == "Steps").items = resp.Record ;
           this.items.find((x) => x.text == "Stories").items = resp.Record ;
        }
      })
    }
  }
  @Watch("context",{immediate: true})
  OnChange(val:any)
  {
    if(this.context=='update')
    {
      this.data={};
      this.$services.commiunicationReport.GetById(this.id).then(resp=>{
        if (resp.Result=="OK") {
          this.items.find((x) => x.text == "Call").items = resp.InitiativeCalls ;
          this.items.find((x) => x.text == "Steps").items = resp.Steps ;
          this.items.find((x) => x.text == "Stories").items = resp.Stories ;
          this.data=resp.Record[0]
          this.disabled=true
          this.showEdit=true
          }
      })
    }
    if(this.context=='create')
    {
      this.data={};
      this.disabled=false
      this.showEdit=false
    }
   }
}
